import React from 'react'
import Grid from '@mui/material/Grid'
import FormControl from '@mui/material/FormControl'
import { useTranslation } from 'react-i18next'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import trim from 'lodash/trim'
import { Typography } from '@mui/material'

import { Project as ProjectType } from 'types/Project'
import OptionWithTooltip, {
  shouldShowTooltip,
} from 'components/Shared/OptionWithTooltip'
import {
  DEFAULT_CHAR_LIMIT,
  DEFAULT_PRM_TOOLTIP_TRUNC_CHAR_LIMIT,
} from 'lib/GlobalConstants'

interface PRMActivityNoteFilterProps {
  projects: ProjectType[]
  setProjectIdForFilter: (arg1: string) => void
}

export const renderOptions = (props: any, option: ProjectType) => {
  const customProps = { ...props, ...{ key: option.id } }
  const trimmedOptionName = trim(option.name)
  return (
    <li {...customProps}>
      <>
        {trimmedOptionName.length > DEFAULT_CHAR_LIMIT &&
        shouldShowTooltip(
          trimmedOptionName,
          DEFAULT_PRM_TOOLTIP_TRUNC_CHAR_LIMIT,
        ) ? (
          <OptionWithTooltip
            option={trimmedOptionName}
            charLimit={DEFAULT_PRM_TOOLTIP_TRUNC_CHAR_LIMIT}
            noWrap={false}
          />
        ) : (
          <Typography noWrap={false}>{trimmedOptionName}</Typography>
        )}
      </>
    </li>
  )
}

const PRMActivityNoteFilter = (props: PRMActivityNoteFilterProps) => {
  const { setProjectIdForFilter, projects } = props
  const { t } = useTranslation()

  const handleChange = async (
    _: React.SyntheticEvent,
    option: ProjectType | null,
  ) => {
    if (option) {
      setProjectIdForFilter(option.id)
      return option
    } else {
      setProjectIdForFilter('')
      return ''
    }
  }

  return (
    // We need to add a unique Key to the filter as each addition in notes needs to remount this filter component
    <Grid container direction="row-reverse">
      <Grid item xs={12} md={4}>
        <FormControl variant="standard" fullWidth>
          <Autocomplete
            data-testid="prmActivityNoteFilter-Select"
            openOnFocus
            onChange={handleChange}
            isOptionEqualToValue={(option, value) =>
              trim(option.name) == trim(value.name)
            }
            options={projects}
            getOptionLabel={(option) => {
              return trim(option.name)
            }}
            noOptionsText={t('common.noOptions')}
            renderOption={renderOptions}
            openText={t('filters.ariaTexts.open')}
            closeText={t('filters.ariaTexts.close')}
            clearText={t('filters.ariaTexts.clear')}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                label={t('participant.prmActivityNoteFilter.label')}
              />
            )}
          />
        </FormControl>
      </Grid>
    </Grid>
  )
}

export default PRMActivityNoteFilter
